import { render } from "./TheLoading.vue?vue&type=template&id=601cc83f&scoped=true"
import script from "./TheLoading.vue?vue&type=script&lang=js"
export * from "./TheLoading.vue?vue&type=script&lang=js"

import "./TheLoading.vue?vue&type=style&index=0&id=601cc83f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601cc83f"]])

export default __exports__